import React from "react";
import { Link } from "react-router-dom";
import AppWrapper from "../Common/AppWrapper/index.jsx";
import "./FeaturedContent.scss";

const FeaturedCentromericCopyNumberReferenceAssays = () => {
  return (
    <AppWrapper
      id="featured-cnd"
      pageTitle="Featured Centromeric Copy Number Assays"
      pageKeywords="Centromeric Copy Number Assays, expert design, curated list"
      pageDescription="Validated copy number reference assays located in the centromeric region of each chromosome (both p and q arms) have been designed for droplet digital PCR. "
    >
      <div id="bg">
        <div id="bg-inner"></div>
      </div>
      <div className="container main-content">
        <div className="row">
          <div className="col-md-12">
            <div id="page-header">
              <div id="page-header-inner" className="row align-items-center">
                <div className="col-md-9">
                  <h1>Centromeric Copy Number Reference Assays</h1>
                </div>

                <div className="col-md-3">
                  {/*
                  <div className="btn-app float-right">
                    <Link to="/digital-assays/assays-create/cnd">
                      <img
                        className="default"
                        src={require("../../digital-assays/assets/images/icons/icon_cnd-white.svg")}
                      />
                      <img
                        className="hover"
                        src={require("../../digital-assays/assets/images/icons/icon_cnd-white-hover.svg")}
                      />
                      <div className="text-center">
                        <span>
                          Copy Number
                          <br />
                          Determination
                        </span>
                      </div>
                    </Link>
                  </div>
                  */}
                </div>
              </div>
            </div>

            <div className="copy">
              <p>
                With the advent of whole genome data, the study of copy number
                variation is rapidly being adopted. Approximately 12% of the
                genome has been found to be copy number variable in the normal
                population. Somatic copy number alterations (SCNA) are often
                druggable, such as HER2, where a patient’s copy number
                determines the administration of drugs.​
              </p>
              <strong>Key Insights:</strong>
              <ul>
                <li>
                  Tumor heterogeneity is present and problematic in many
                  cancers​
                </li>
                <li>
                  A single reference is often inadequate for determining copy
                  number​
                </li>
                <li>
                  In cancer, the chromosome centromere is more stable than the
                  arms​
                </li>
                <li>
                  Chromosome enumeration, focal vs. arm-level amplifications​
                </li>
              </ul>
              <p>
                Validated copy number reference assays located in the
                centromeric region of each chromosome (both p and q arms) have
                been designed for digital and are available with either FAM or
                HEX for use with the QX200 ddPCR system and additionally with
                Cy5 or Cy5.5 fluorophores for use with the QX ONE ddPCR System.​
              </p>
              <br />
              <br />

              <div className="table-header">Chromosome 1</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    HAO2
                  </td>
                  <td rowspan="2">(1p12)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506296"}>
                      dHsaCP2506296
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506713"}>
                      dHsaCP2506713
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    NOTCH2
                  </td>
                  <td rowspan="2">(1p12)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP1000518"}>
                      dHsaCP1000518
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506355"}>
                      dHsaCP2506355
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    CD160
                  </td>
                  <td rowspan="2">(1q21.1)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506269"}>
                      dHsaCP2506269
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506689"}>
                      dHsaCP2506689
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 2</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    THNSL2
                  </td>
                  <td rowspan="2">(2p11.2)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506297"}>
                      dHsaCP2506297
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506732"}>
                      dHsaCP2506732
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    MRPS5
                  </td>
                  <td rowspan="2">(2q11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506282"}>
                      dHsaCP2506282
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506697"}>
                      dHsaCP2506697
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 3</div>

              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    EPHA3
                  </td>
                  <td rowspan="2">(3p11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506272"}>
                      dHsaCP2506272
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506680"}>
                      dHsaCP2506680
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    ARL13B
                  </td>
                  <td rowspan="2">(3q11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506267"}>
                      dHsaCP2506267
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506677"}>
                      dHsaCP2506677
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    NSUN3
                  </td>
                  <td rowspan="2">(3q11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506284"}>
                      dHsaCP2506284
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506682"}>
                      dHsaCP2506682
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 4</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    FRYL
                  </td>
                  <td rowspan="2">(4p11)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506298"}>
                      dHsaCP2506298
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506710"}>
                      dHsaCP2506710
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    SLAIN2
                  </td>
                  <td rowspan="2">(4p11)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506299"}>
                      dHsaCP2506299
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506727"}>
                      dHsaCP2506727
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    DCUN1D4
                  </td>
                  <td rowspan="2">(4q12)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506300"}>
                      dHsaCP2506300
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506707"}>
                      dHsaCP2506707
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    SPATA18
                  </td>
                  <td rowspan="2">(4q12)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506301"}>
                      dHsaCP2506301
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506728"}>
                      dHsaCP2506728
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 5</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    HCN1
                  </td>
                  <td rowspan="2">(5p12)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506277"}>
                      dHsaCP2506277
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506694"}>
                      dHsaCP2506694
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    ITGA2
                  </td>
                  <td rowspan="2">(5q11.2)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506279"}>
                      dHsaCP2506279
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506695"}>
                      dHsaCP2506695
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    PARP8
                  </td>
                  <td rowspan="2">(5q11.1)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506286"}>
                      dHsaCP2506286
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506700"}>
                      dHsaCP2506700
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 6</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    DST
                  </td>
                  <td rowspan="2">(6p12.1)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506302"}>
                      dHsaCP2506302
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506708"}>
                      dHsaCP2506708
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    KHDRBS2
                  </td>
                  <td rowspan="2">(6q11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506281"}>
                      dHsaCP2506281
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506681"}>
                      dHsaCP2506681
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 7</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    VOPP1
                  </td>
                  <td rowspan="2">(7p11.2)</td>
                  <td rowspan="2">64</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506292"}>
                      dHsaCP2506292
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506684"}>
                      dHsaCP2506684
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    ASL
                  </td>
                  <td className="first" rowspan="2">
                    (7q11.21)
                  </td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506268"}>
                      dHsaCP2506268
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506678"}>
                      dHsaCP2506678
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    CRCP
                  </td>
                  <td rowspan="2">(7q11.21)</td>
                  <td rowspan="2">63</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506271"}>
                      dHsaCP2506271
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506679"}>
                      dHsaCP2506679
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 8</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ANK1
                  </td>
                  <td rowspan="2">(8p11.21)</td>
                  <td rowspan="2">65</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506264"}>
                      dHsaCP2506264
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506686"}>
                      dHsaCP2506686
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    RNF170
                  </td>
                  <td rowspan="2">(8p11.21)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506287"}>
                      dHsaCP2506287
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506701"}>
                      dHsaCP2506701
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    CEBPD
                  </td>
                  <td rowspan="2">(8q11.21)</td>
                  <td rowspan="2">61</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506270"}>
                      dHsaCP2506270
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506690"}>
                      dHsaCP2506690
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 9</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ALDH1B1
                  </td>
                  <td rowspan="2">(9p13.2)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506303"}>
                      dHsaCP2506303
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506705"}>
                      dHsaCP2506705
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    IGFBPL1
                  </td>
                  <td rowspan="2">(9p13.1)</td>
                  <td rowspan="2">66</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506304"}>
                      dHsaCP2506304
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506715"}>
                      dHsaCP2506715
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 10</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ANKRD30A
                  </td>
                  <td rowspan="2">(10p11.21)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506265"}>
                      dHsaCP2506265
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506687"}>
                      dHsaCP2506687
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 11</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    KBTBD4
                  </td>
                  <td rowspan="2">(11p11.2)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506280"}>
                      dHsaCP2506280
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506696"}>
                      dHsaCP2506696
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    MTCH2
                  </td>
                  <td rowspan="2">(11p11.2)</td>
                  <td rowspan="2">65</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506283"}>
                      dHsaCP2506283
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506698"}>
                      dHsaCP2506698
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 12</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    SYT10
                  </td>
                  <td rowspan="2">(12p11.1)</td>
                  <td rowspan="2">67</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506305"}>
                      dHsaCP2506305
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506731"}>
                      dHsaCP2506731
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    IRAK4
                  </td>
                  <td rowspan="2">(12q12)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506307"}>
                      dHsaCP2506307
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506717"}>
                      dHsaCP2506717
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    KIF21A
                  </td>
                  <td rowspan="2">(12q12)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506306"}>
                      dHsaCP2506306
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506719"}>
                      dHsaCP2506719
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 13</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    GJA3
                  </td>
                  <td rowspan="2">(13q12.11)</td>
                  <td rowspan="2">57</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506308"}>
                      dHsaCP2506308
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506712"}>
                      dHsaCP2506712
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    ZMYM2
                  </td>
                  <td rowspan="2">(13q12.11)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506309"}>
                      dHsaCP2506309
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506736"}>
                      dHsaCP2506736
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 14</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    TTC5
                  </td>
                  <td rowspan="2">(14q11.2)</td>
                  <td rowspan="2">59</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506310"}>
                      dHsaCP2506310
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506733"}>
                      dHsaCP2506733
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 15</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    NIPA1
                  </td>
                  <td rowspan="2">(15q11.2)</td>
                  <td rowspan="2">61</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2500262"}>
                      dHsaCP2500262
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506396"}>
                      dHsaCP2506396
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    NIPA2
                  </td>
                  <td rowspan="2">(15q11.2)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2500263"}>
                      dHsaCP2500263
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506397"}>
                      dHsaCP2506397
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 16</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ITGAD
                  </td>
                  <td rowspan="2">(16p11.2)</td>
                  <td rowspan="2">68</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506311"}>
                      dHsaCP2506311
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506718"}>
                      dHsaCP2506718
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    ZNF843
                  </td>
                  <td rowspan="2">(16p11.2)</td>
                  <td rowspan="2">60</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506312"}>
                      dHsaCP2506312
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506737"}>
                      dHsaCP2506737
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    MYLK3
                  </td>
                  <td rowspan="2">(16q11.2)</td>
                  <td rowspan="2">61</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506314"}>
                      dHsaCP2506314
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506721"}>
                      dHsaCP2506721
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    ORC6
                  </td>
                  <td rowspan="2">(16q11.2)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506313"}>
                      dHsaCP2506313
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506722"}>
                      dHsaCP2506722
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 17</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="first" className="even">
                  <td className="first" rowspan="2">
                    TMEM11
                  </td>
                  <td rowspan="2">(17p11.2)</td>
                  <td rowspan="2">58</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506291"}>
                      dHsaCP2506291
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506683"}>
                      dHsaCP2506683
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    WSB1
                  </td>
                  <td rowspan="2">(17q11.1)</td>
                  <td rowspan="2">63</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506294"}>
                      dHsaCP2506294
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506685"}>
                      dHsaCP2506685
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 18</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ANKRD30B
                  </td>
                  <td rowspan="2">(18p11.21)</td>
                  <td rowspan="2">64</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506266"}>
                      dHsaCP2506266
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506688"}>
                      dHsaCP2506688
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    GREB1L
                  </td>
                  <td rowspan="2">(18q11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506276"}>
                      dHsaCP2506276
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506693"}>
                      dHsaCP2506693
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 19</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    PLEKHF1
                  </td>
                  <td rowspan="2">(19q12)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506315"}>
                      dHsaCP2506315
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506723"}>
                      dHsaCP2506723
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    URI1
                  </td>
                  <td rowspan="2">(19q12)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506316"}>
                      dHsaCP2506316
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506734"}>
                      dHsaCP2506734
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 20</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ENTPD6
                  </td>
                  <td rowspan="2">(20p11.21)</td>
                  <td rowspan="2">65</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506317"}>
                      dHsaCP2506317
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506709"}>
                      dHsaCP2506709
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    GINS1
                  </td>
                  <td rowspan="2">(20p11.21)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506318"}>
                      dHsaCP2506318
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506711"}>
                      dHsaCP2506711
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ID1
                  </td>
                  <td rowspan="2">(20q11.21)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506319"}>
                      dHsaCP2506319
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506714"}>
                      dHsaCP2506714
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    SUN5
                  </td>
                  <td rowspan="2">(20q11.21)</td>
                  <td rowspan="2">61</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506320"}>
                      dHsaCP2506320
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506730"}>
                      dHsaCP2506730
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 21</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    RBM11
                  </td>
                  <td rowspan="2">(21q11.2)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506321"}>
                      dHsaCP2506321
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506724"}>
                      dHsaCP2506724
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    SAMSN1
                  </td>
                  <td rowspan="2">(21q11.2)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506322"}>
                      dHsaCP2506322
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506726"}>
                      dHsaCP2506726
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome 22</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    IL17RA
                  </td>
                  <td rowspan="2">(22q11.1)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506323"}>
                      dHsaCP2506323
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506716"}>
                      dHsaCP2506716
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome X</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    KLF8
                  </td>
                  <td rowspan="2">(Xp11.21)</td>
                  <td rowspan="2">64</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506324"}>
                      dHsaCP2506324
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506720"}>
                      dHsaCP2506720
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    RRAGB
                  </td>
                  <td rowspan="2">(Xp11.21)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506325"}>
                      dHsaCP2506325
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506725"}>
                      dHsaCP2506725
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    ARHGEF9
                  </td>
                  <td rowspan="2">(Xq11.1)</td>
                  <td rowspan="2">66</td>
                  <td rowspan="2">&nbsp;crosses exon-intron junction</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506327"}>
                      dHsaCP2506327
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506706"}>
                      dHsaCP2506706
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td className="first" rowspan="2">
                    SPIN4
                  </td>
                  <td rowspan="2">(Xq11.1)</td>
                  <td rowspan="2">70</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506326"}>
                      dHsaCP2506326
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506729"}>
                      dHsaCP2506729
                    </Link>
                  </td>
                </tr>
              </table>

              <div className="table-header">Chromosome Y</div>
              <table>
                <tr>
                  <th className="col1">Gene</th>
                  <th className="col2">Chromosome&nbsp;Location</th>
                  <th className="col3">Amplicon&nbsp;Length</th>
                  <th className="col4">Position</th>
                  <th className="col5">Fluor</th>
                  <th className="col6">Assay ID</th>
                </tr>
                <tr className="even">
                  <td className="first" rowspan="2">
                    USP9Y
                  </td>
                  <td rowspan="2">(Yq11.21)</td>
                  <td rowspan="2">69</td>
                  <td rowspan="2">&nbsp;exonic</td>
                  <td>&nbsp;FAM</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506328"}>
                      dHsaCP2506328
                    </Link>
                  </td>
                </tr>
                <tr className="even">
                  <td>&nbsp;HEX</td>
                  <td>
                    <Link to={"/digital-assays/assay-detail/dHsaCP2506735"}>
                      dHsaCP2506735
                    </Link>
                  </td>
                </tr>
              </table>
            </div>

            <div id="call-to-action">
              <h1>Design Your Assay</h1>
              <div className="btn-app">
                <Link to="/digital-assays/assays-create/cnd">
                  <div className="btn-icon cnd" />
                  <span>
                    Copy Number
                    <br />
                    Determination
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppWrapper>
  );
};

export default FeaturedCentromericCopyNumberReferenceAssays;
